import React, { Fragment, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { priceToFloat } from 'helpers/ProductUtils';
import { SmallLoader } from 'components/Loader';
import {
  getLists,
  getListsForItemId,
  heartProduct,
  toggleHeartingLoginModal,
  unHeartProduct
} from 'actions/hearts';
import NewCollectionModal from 'components/account/NewCollectionModal';

import css from 'styles/components/account/socialCollectionsWidget.scss';

export const SocialCollectionsWidget = ({
  canAddNewCollection = false,
  heartProduct,
  unHeartProduct,
  isCustomer,
  getStyleId,
  getLists,
  getListsForItemId,
  toggleHeartingLoginModal,
  hearts,
  colorId,
  productId,
  price,
  missingDimension,
  sourcePage
}) => {
  const listContainer = useRef();
  const [showMore, setShowMore] = useState(false);
  const [showNewCollectionModal, setNewCollectionModal] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const itemId = getStyleId();
  const priceAsFloat = typeof price === 'string' ? priceToFloat(price) : price;

  const {
    lists,
    itemIdLists
  } = hearts;

  const bindCloseEvent = e => {
    if (!e.target.closest(`[data-collection="${itemId}"]`)) {
      setShowMore(false);
      document.body.removeEventListener('click', bindCloseEvent);
    }
  };

  const onGetListsForItemId = () => {
    getListsForItemId({ itemId }).then(() => {
      setLoading(false);
      listContainer.current?.focus();
    });
  };

  const onCollectionOpenToggle = () => {
    if (!isCustomer) {
      return toggleHeartingLoginModal(true);
    }

    if (!showMore) {
      document.body.addEventListener('click', bindCloseEvent);
      if (!lists) {
        getLists().then(onGetListsForItemId);
      } else {
        onGetListsForItemId();
      }

      setLoading(true);
    }

    setShowMore(!showMore);
  };

  const onCollectionChange = e => {
    const { checked, id } = e.currentTarget;
    setLoading(true);

    // `checked` comes back as the state it "will be" once its been clicked
    const heartType = checked ? heartProduct : unHeartProduct;
    heartType({ itemId, listId: id, colorId, productId, price: priceAsFloat, missingDimension, sourcePage }, onGetListsForItemId);
  };

  const onSaveNewCollection = response => {
    const { listId } = response;
    setNewCollectionModal(false);
    setShowMore(true);

    heartProduct({ itemId, listId, productId, colorId, price: priceAsFloat, missingDimension, sourcePage }, () => {
      getLists().then(onGetListsForItemId);
    });
  };

  return (
    <>
      { canAddNewCollection &&
        <NewCollectionModal
          showNewCollectionModal={showNewCollectionModal}
          onCancelModal={setNewCollectionModal.bind(this, false)}
          onDoneModal={onSaveNewCollection} />
      }

      <div className={css.container} data-collection={itemId}>
        <button type="button" className={css.addToButton} onClick={onCollectionOpenToggle}>Add to a Collection</button>
        {
          showMore &&
          <div className={css.lists} tabIndex="-1" ref={listContainer}>
            { canAddNewCollection &&
              <button
                type="button"
                className={css.addNew}
                aria-expanded={showMore}
                onClick={setNewCollectionModal.bind(this, true)}>
              Add to new Collection
              </button>
            }

            { (lists && itemIdLists && !isLoading)
              ? lists.map(({ listId, name }) => {
                const matchingList = itemIdLists.find(itemIdList => listId === itemIdList.listId);
                return (
                  <Fragment key={listId}>
                    <input
                      id={`${listId}`}
                      onChange={onCollectionChange}
                      defaultChecked={matchingList}
                      type="checkbox" />
                    <label htmlFor={`${listId}`}>{name}</label>
                  </Fragment>
                );
              })
              : <SmallLoader />
            }
          </div>
        }
      </div>
    </>
  );
};

export const mapStateToProps = state => ({
  isCustomer: !!state.cookies['x-main'],
  hearts: state.hearts
});

export default connect(mapStateToProps, {
  getLists,
  getListsForItemId,
  heartProduct,
  unHeartProduct,
  toggleHeartingLoginModal
})(SocialCollectionsWidget);
